import { NavLink } from "react-router";
import { useRef, useState } from "react";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const collapseRef = useRef(null) as any;
  
  const toggleMenu = () => {
    const el = collapseRef.current;
    if (!el) return;

    if (!menuOpen) {
      // EXPAND
      el.style.display = "block";
      const height = el.scrollHeight;
      el.style.height = "0px";
      el.style.transition = "height 0.35s ease";
      el.style.height = height + "px";
    } else {
      collapse();
    }

    setMenuOpen(!menuOpen);
  };

  const handleTransitionEnd = () => {
    const el = collapseRef.current;
    if (!menuOpen) {
      el.style.display = "none";
    } else {
      el.style.height = "auto";
    }
  };
  
  const collapse = () => {    
    const el = collapseRef.current;
    if (!el) return;
    el.style.height = el.scrollHeight + "px";
    el.style.transition = "height 0.35s ease";
    el.style.height = "0px";
    setMenuOpen(false);
  }

  return (
    <nav className="navbar navbar-expand-lg bg-orange w-100 p-2">
      <NavLink to="home" onClick={collapse} className="navbar-brand App-link js-scroll-trigger title-font link-text">Ms. Tamborello's Art Class</NavLink>
      <button className="navbar-toggler" type="button" onClick={toggleMenu} aria-expanded={menuOpen} aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
      </button>
      <div ref={collapseRef} onTransitionEnd={handleTransitionEnd} className={`collapse navbar-collapse ${menuOpen ? "show" : ""} custom-navbar-show`}>
        <ul className="navbar-nav mr-auto">
          <li className="nav-item">
            <NavLink onClick={collapse} className="dropdown-item text-color header-item js-scroll-trigger" to="/studentwork">Student Work</NavLink>
          </li>
          <li className="nav-item">
            <NavLink onClick={collapse} className="dropdown-item text-color header-item js-scroll-trigger" to="/lessons">Lessons</NavLink>
          </li>
          <li className="nav-item link-text">
            <NavLink onClick={collapse} className="dropdown-item text-color header-item js-scroll-trigger" to="/about">About</NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Header;